// 布局
import React, { useState, useEffect, useMemo, useRef } from 'react';
import './theme.global.less';
import { Layout, Menu, Dropdown, Tooltip, Typography } from 'antd';
import NotFound from '@/common/components/NotFound';
import IconFont from '@/common/components/IconFont';
import ChangeAccount from '@/layout/components/Login/components/ChangeAccount';
import MustReadBeforeDev from './components/MustReadBeforeDev';
import { get } from '@/common/request/index';
import { recursionEach, dateFns, deepCopy, isArray, isNotEmptyAny, debounce, getKeysFromObjectArray } from '@lhb/func';
import { isLarkEnv, isMobileDevice, logout } from '@/common/utils/ways';
import { tntList, tenantCheck, getConfigCustomField, postConfigCustomField } from '@/common/api/common';
import { UserInfoContextProvider } from './context';
import cs from 'classnames';
import { currentUserInfo, CurrentUserInfo, UserInfoModuleList } from '@/common/api/brief';
import { devMenu } from './menuConfig';
import { BasicType, HeaderStatus, MapThemeEnum, MapThemeLabelEnum, defaultMapStyle, filterTargetLevelIcon, foldUrl, fullContentUrl } from './ts-config';
// import { loadMicroApp } from 'qiankun';
// import { config } from '@/common/qiankun/config';
import styles from './index.module.less';
import { dispatchNavigate } from '@/common/document-event/dispatch';
// import { routersConfig } from '@/router/router';
import { getTenantInfo } from '@/common/api/system';
import { useDispatch, useSelector } from 'react-redux';
import { changeTenantInfo, UPDATE_TENANT_CHECK_INFO, changeTheme, UPDATE_CURRENT_USER_INFO } from '@/store/common';
import { getCookie, getStorage, removeCookie, setCookie, setStorage } from '@lhb/cache';
// import { getRegisterTrialStatus } from '@/common/api/user';
import { bigdataMenu } from '@/common/utils/bigdata';
import { componentDocsMenu } from './componentMenuConfig';
import Logo from 'src/layout/components/Logo';
import EditPasswordModal from './components/Password/EditPasswordModal';
import ResetPasswordModal from './components/Password/ResetPasswordModal';
import Breadcrumb from './components/Breadcrumb';
import HeaderUserInfo from './components/HeaderUserInfo';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { useMethods } from '@lhb/hook';
import MapBGRadio from './components/MapBGRadio';
import DownLoadRecord from './components/DownLoadRecord';
import { removeDownloadRemind } from '@/common/document-event/remove';
import { onDownloadRemind } from '@/common/document-event/on';
import { unstable_batchedUpdates } from 'react-dom';
import V2WaterMark from '@/common/components/Others/V2WaterMark';
import V2Tabs from '@/common/components/Data/V2Tabs';
import { userPermissionList } from '@/common/api/permission';
export const siderWrap = 'siderWrap';
// const routeList = routersConfig(); // 不能在jsx内执行，需要在Main函数之前就调用，才能获取到正确的页面组件

const { Header, Sider, Content } = Layout;
export interface UserInfoProps extends CurrentUserInfo {
  haveMenu?: boolean;
  menusItems: any[];
  getTenantDetail?: Function;
  tenantInfo?: any;
  pageConfig?:any;
  menuList?: any[];
  mapConfig?: any;
}

const Component: React.FC<BasicType> = ({ children, location }) => {
  const dispatch = useDispatch();
  const setCollapsedTimer: any = useRef(); // 用来放置去重setCollapsed的setTimeout行为的
  const theme = useSelector((state: any) => state.common.theme);
  const tenantCheckInfo = useSelector((state: any) => state.common.tenantCheck);
  const [themeRenderReady, setThemeRenderReady] = useState<boolean>(false);
  const [selectKey, setSelectKey] = useState<string[]>([location.to.pathname]);
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const [showAccountModal, setShowAccountModal] = useState<boolean>(false);
  const [havePermission, setHavePermission] = useState<boolean>(true); // 是否有页面权限
  const [showChangeEnter, setShowChangeEnter] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<UserInfoProps>({
    haveMenu: true,
    menusItems: [],
  });
  const [menus, setMenus] = useState<any[]>([]); // 各层级菜单平铺后数组
  const [defaultOpenKeys, setDefaultOpenKeys] = useState<Array<string>>([]);
  const [tenantInfo, setTenantInfo] = useState<any>({});
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
  const [editModal, setEditModal] = useState<boolean>(false);// 是否打开修改密码弹窗
  const [resetModal, setResetModal] = useState<boolean>(false);// 是否打开忘记密码弹窗
  const [pageConfig, setPageConfig] = useState<any>({});// 页面配置
  const [headerOpen, setHeaderOpen] = useState<boolean>(false);
  const isDev = process.env.NODE_ENV === 'development'; // 是否是开发环境
  const [mapConfig, setMapConfig] = useState<any>({
    bg: getStorage('MAP_BG_CONFIG') || defaultMapStyle // 默认标准
  });

  const [downLoadTipAnimate, setDownLoadTipAnimate] = useState<any>({
    animation: false,
    left: 0,
  }); // 是否展示引导动效
  const [downLoadTipHigh, setDownLoadTipHigh] = useState<boolean>(false); // 是否弹出提示弹窗
  const [downLoadTipOpen, setDownLoadTipOpen] = useState<boolean>(false); // 是否弹出提示弹窗
  const [downLoadVisible, setDownLoadVisible] = useState<boolean>(false); // 导出记录弹窗
  const [personalPer, setPersonalPer] = useState<any[]>([]); // 个人中心按钮权限，目前有 重置密码	、修改密码
  const downLoadTipTimer: any = useRef(); // 提示动效去重，0.8s
  const downLoadTipHighTimer: any = useRef(); // 提示高亮去重，3s

  const waterText = useMemo(() => {
    if (userInfo?.name) {
      if (userInfo.mobile) {
        return `${userInfo.name} ${userInfo.mobile.slice(-4)}`;
      }
      return userInfo.name;
    }
    return '';
  }, [userInfo]);

  /**
 * 计算个人权限状态对象。
 */
  const personalPerArr = useMemo(() => {
    const enCodeArr = getKeysFromObjectArray(personalPer, 'enCode')?.map(itm => itm.split(':')?.[1]);
    return {
      [HeaderStatus.EDIT_PASSWORD]: enCodeArr.includes(HeaderStatus.EDIT_PASSWORD),
      [HeaderStatus.RESET_PASSWORD]: enCodeArr.includes(HeaderStatus.RESET_PASSWORD),
    };
  }, [personalPer]);

  useEffect(() => {
    // 注释原因：20240815版本去掉了试用账号逻辑
    // getRegisterTrialStatus().then((res) => {
    // if (res.initStatus) { // 如果是数据初始化完成的就开始正常走逻辑
    getEnterprises();
    getCurrentUser();
    getTenantDetail();
    getTargetTenent();
    methods.getPersonalMenu();
    //   } else { // 如果还在获取中，去获取数据的loading等待页
    //     dispatchNavigate('/openweb');
    //   }
    // });
    // 如果cookie里有theme就提前插入
    if (theme === 'light') {
      // 主题替换，浅色主题
      if (!document.body.classList.contains('global-theme-light-var')) {
        document.body.classList.add('global-theme-light-var');
      }
    }
    // 插入默认主题色
    if (!document.body.classList.contains('global-theme-base-var')) {
      document.body.classList.add('global-theme-base-var');
    }
    onDownloadRemind(methods.downloadRemind);
    return () => {
      removeDownloadRemind(methods.downloadRemind);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (theme === 'light') {
      // 主题替换，浅色主题
      if (!document.body.classList.contains('global-theme-light-var')) {
        document.body.classList.add('global-theme-light-var');
      }
    } else {
      // 主题替换，移除浅色主题
      if (document.body.classList.contains('global-theme-light-var')) {
        document.body.classList.remove('global-theme-light-var');
      }
    }
  }, [theme]);

  // 是否没有padding，撑满一屏，目前只有地图要求撑满
  const isFullPage = useMemo(() => {
    const pathname = location.to.pathname;
    return foldUrl.includes(pathname) || fullContentUrl.includes(pathname);
  }, [location.to.pathname]);

  const isALQ = useMemo(() => {
    return !!tenantCheckInfo?.isALQ;
  }, [tenantCheckInfo]);

  // /iframe 页面比较特殊，产品可能配置路由 pathname=/iframe?url=xxx#hash，如果在 menus 中通过完整路由匹配到了，就使用完整路由作为选中 key
  const pathname = useMemo(() => {
    if (location.to.pathname === '/iframe') {
      return `${location.to.pathname}${location.to.search || ''}${location.to.hash || ''}`;
    }
    return location.to.pathname;
  }, [location.to.pathname, location.to.search, location.to.hash]);

  useEffect(() => {
    const tenantId = getCookie('tenantId');// 租户id
    const employeeId = getCookie('employeeId');// 员工id
    const msg: any = {
      report_time: dateFns.currentTime('', false),
    };
    if (tenantId || tenantInfo?.id) msg.tenant_id = tenantId || tenantInfo?.id;
    if (employeeId || userInfo?.id) msg.user_id = employeeId || userInfo?.id;

    // 20230824版本，为了统一埋点上报方式，取消eventId方式的上报
    // 埋点上报
    // pageConfig?.eventId && window.LHBbigdata.send({
    //   event_id: pageConfig.eventId, // 事件id
    //   msg
    //   // msg: {
    //   //   tenant_id: tenantId || tenantInfo?.id, // 租户id
    //   //   user_id: employeeId || userInfo?.id, // 员工id
    //   //   report_time: dateFns.currentTime('', false),
    //   // } // 额外需要插入的业务信息
    // });
    // 部分子页面访问时上报归属的父级页面 https://confluence.lanhanba.com/pages/viewpage.action?pageId=67530354
    const { url } = pageConfig;
    url && window.LHBbigdata.send({
      msg: {
        url,
        ...msg
      }
    });
  }, [pageConfig, tenantInfo?.id, userInfo?.id]);

  useEffect(() => {
    if (userInfo.haveMenu && userInfo.moduleList) {
      if (pageConfig?.parentPath) {
        setDefaultOpenKeys(pageConfig?.parentPath);
      } else {
        recursionEach(userInfo.moduleList, 'children', (item: any) => {
          if (item.uri === location.to.pathname && item.parent) {
            // 有父级节点才默认展开-父节点的uri可能回null，此时取encode与渲染menu对应
            setDefaultOpenKeys([item.parent.uri || item.parent.encode]);
            setSelectKey(item.uri);
            return true;
          } else {
            return false;
          }
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.moduleList]);

  useEffect(() => {
    // const isShareHasToken = getStorage('IS_SHARE__HAS_TOEKN');
    // if (isShareHasToken) {
    //   removeCookie('flow_token');
    //   removeStorage('IS_SHARE__HAS_TOEKN');
    //   window.location.replace('/');
    //   return;
    // }

    // /iframe 页面比较特殊，产品可能配置路由 pathname=/iframe?url=xxx#hash，如果在 menus 中通过完整路由匹配到了，就使用完整路由作为选中 key
    if (location.to.pathname === '/iframe' && menus?.some(item => item.uri === pathname)) {
      const item = menus?.find(item => item.uri === pathname);
      document.title = `${item?.name}`;
      // 等待上面监听 userInfo.moduleList 处理菜单完成，再设置展开的菜单
      item.parent && setTimeout(() => {
        const key = item.parent.uri || item.parent.encode;
        setDefaultOpenKeys(val => ([...val, key]));
      }, 100);
    }

    selectKey.length && selectKey[0] !== pathname && setSelectKey([pathname]);
    if (userInfo.moduleList?.length) {

      clearTimeout(setCollapsedTimer.current);
      // 防止因foldUrl配置的菜单为菜单第一项，在刷新页面或者默认进入时，默认展开二级菜单
      setCollapsedTimer.current = setTimeout(() => {
        if (foldUrl.includes(pathname)) { // 进入指定的页面时收起
          setCollapsed(true);
        } else { // 否则默认展开
          methods.changeCollapsedFalse();
        }
      }, 0);
    }
  }, [pathname, userInfo]);

  // 可以跳出局限，collapsed可以变成全局被使用
  const methods = useMethods({
    getCollapsed() {
      return collapsed;
    },
    toggle() {
      if (!collapsed) {
        setCollapsed(true);
      } else {
        methods.changeCollapsedFalse();
      }
    },
    changeCollapsedFalse() {
      if (isMobileDevice()) {
        setCollapsed(false);
      } else {
        const element = document.querySelector('.ant-menu-inline-collapsed .ant-tooltip-open');
        element?.dispatchEvent(new MouseEvent('mouseout', {
          bubbles: true,
        }));
        clearTimeout(setCollapsedTimer.current);
        setCollapsedTimer.current = setTimeout(() => {
          setCollapsed(false);
        }, 150);
      }
    },
    downloadRemind() {
      setDownLoadTipAnimate({
        animation: false,
        left: 0,
      });
      setTimeout(() => {
        const target = document.getElementById('layout-top-download-draw-icon');
        if (target) {
          const rect = target.getBoundingClientRect();
          unstable_batchedUpdates(() => {
            setDownLoadTipAnimate({
              animation: true,
              left: rect.left - 24 + 8,
            });
            setDownLoadTipHigh(true);
          });
          clearTimeout(downLoadTipTimer.current);
          clearTimeout(downLoadTipHighTimer.current);
          downLoadTipTimer.current = setTimeout(() => {
            setDownLoadTipAnimate({
              animation: false,
              left: rect.left - 24 + 8,
            });
          }, 800);
          downLoadTipHighTimer.current = setTimeout(() => {
            setDownLoadTipHigh(false);
          }, 3000);
        }
      }, 1);
    },
    handleDownLoadTipOpenChange(open) {
      setDownLoadTipOpen(open);
    },
    getPersonalMenu() {
      // 获取权限
      userPermissionList({
        encodeList: [
          // 与 src/layout/ts-config.ts HeaderStatus 保持一致
          'personal:resetPassword', // 重置密码
          'personal:editPassword', // 修改密码
        ] }).then(res => {
        setPersonalPer((res));
      });
    },
    handleLogoutALQ() {
      window.location.href = '/microsoft/alq';
    }
  });
  // 将菜单结果处理为menu需要的格式
  const dealWithMenu = (list: any[], hiddenEncodes: string[] = [], isRoot = true) => {
    if (Array.isArray(list) && list.length) {

      // 过滤特殊需求隐藏菜单
      const tmpList = (isArray(hiddenEncodes) && hiddenEncodes.length) ? list.filter((itm: any) => !hiddenEncodes.includes(itm.encode)) : list;

      return tmpList.map((item) => {
        // const simpleUri = item.simpleUri;
        // const uri = item.uri;
        // // 如果存在simpleUri,就把simpleUri和uri做替换
        // if (simpleUri) {
        //   item.simpleUri = uri;
        //   item.uri = simpleUri;
        // }
        const newChildren = dealWithMenu(item.children, hiddenEncodes, false);
        const ToolText = (
          <Typography.Text
            className='customMenuItem'
            ellipsis={{
              tooltip: {
                placement: 'right',
                // 如果是收起的时候，就不再使用label的tooltip，因为menu有默认的tooltip
                title: item.name,
                overlayClassName: styles.collapsedTooltip,
              }
            }}
          >
            {item.name}
          </Typography.Text>
        );
        const newItem = {
          label: (
            isRoot ? (
              <div
                onMouseEnter={e => {
                  // 确保在收起模式下，tooltip失效，因为menu在收起时，默认就有tooltip。会导致两个tooltip重叠
                  if (methods.getCollapsed()) {
                    e.stopPropagation();
                    e.preventDefault();
                  }
                }}
              >
                {ToolText}
              </div>
            ) : ToolText
          ),
          key: item.uri || item.encode,
          icon: item.icon && <IconFont className={styles.menuIcon} iconHref={item.icon} />,
          children: newChildren,
          // title: false // 设置false可以关闭收起状态下的tooltip
        };
        if (newChildren?.length) {
          newItem.popupClassName = styles.sliderItemPopup;
        }
        return newItem;
      });
    } else {
      return null;
    }
  };

  // 将菜单处理为平铺的数组
  const getMenuMap = (list: any[]) => {
    if (Array.isArray(list) && list.length) {
      let allMenus: any[] = [];
      list.forEach((item: any) => {
        const itm = deepCopy(item);
        delete itm.children;
        allMenus.push(itm);

        const children: any[] = getMenuMap(item.children);
        if (isArray(children) && children.length) {
          allMenus = allMenus.concat(children);
        }
      });
      return allMenus;
    } else {
      return [];
    }
  };

  // 获取用户信息（包含菜单列表）
  const getCurrentUser = async () => {
    try {
      const userInfo: CurrentUserInfo = await currentUserInfo();
      dispatch(UPDATE_CURRENT_USER_INFO(userInfo));
      let { moduleList } = userInfo;
      const employeeId = getCookie('employeeId');
      !employeeId && setCookie('employeeId', userInfo.id);
      userInfo?.technicalMobile && setStorage('technicalMobile', userInfo.technicalMobile);
      if (Array.isArray(moduleList) && moduleList.length) {
        filterTargetLevelIcon(moduleList);
        moduleList = moduleList.filter((moduleItem: any) => moduleItem.uri);
      }
      if (isDev && moduleList) {
        // 本地开发时可自定义配置
        moduleList = moduleList.concat(devMenu); // devMenu;
      }
      // 将simpleUri和uri对调，为了解决uri路由映射到simpleUri别名
      recursionEach(moduleList, 'children', (item) => {
        const simpleUri = item.simpleUri;
        const uri = item.uri;
        // 如果存在simpleUri,就把simpleUri和uri做替换
        if (simpleUri) {
          item.simpleUri = uri;
          item.uri = simpleUri;
        }
      });
      const menusItems: any[] = dealWithMenu(moduleList || []);
      const menuList: any[] = getMenuMap(moduleList || []);
      setMenus(menuList);

      setUserInfo({
        ...userInfo,
        haveMenu: !!(moduleList as UserInfoModuleList[]).length,
        moduleList,
        menuList,
        menusItems,
        getTenantDetail
      });
      // 迁移到面包屑组件中
      // src/layout/components/Breadcrumb/index.tsx
      // const currentPath = location.to.pathname;
      // const allUri = getKeys(moduleList as UserInfoModuleList[], [], 'uri', 'children', true);
      // const collectionPath = gatherMethods(pageConfig?.breadcrumbs?.path || [], allUri, 1);
      // const isIN = allUri.includes(currentPath) || collectionPath.length || /^\/demo/.test(currentPath); // 是否可访问：在可访问数组内，或者是 demo 页面
      // // 如果当前页面不在菜单列表中且子菜单所属的父级菜单也不在菜单列表中则默认跳转到第一个页面
      // if (!isIN && moduleList && moduleList.length) {
      //   const target = (moduleList[0] as any).children.length ? (moduleList[0] as any).children[0] : moduleList[0];
      //   target && dispatchNavigate(target.uri);
      //   target && selectKey.length && selectKey[0] !== target.uri && setSelectKey(target.uri);
      // }
      // // 如果没有菜单权限-且不在404页面则页面全局提示暂无权限
      // if (moduleList && !moduleList.length && currentPath !== '/404') {
      //   setHavePermission(false);
      // }
    } catch (error) {
      console.log('error', error);
      dispatchNavigate('/404');
    }
  };

  // 获取企业列表
  const getEnterprises = () => {
    tntList().then((data: any) => {
      if (Array.isArray(data)) {
        const enterprises = data.filter((enterprise: any) => enterprise.status !== 2);
        if (enterprises.length > 1) {
          // 多个企业时才显示切换企业按钮
          setShowChangeEnter(true);
        }
        return;
      }
      setShowChangeEnter(false);
    });
  };

  const handleClick = ({ selectedKeys }) => {
    if (selectedKeys.length) {
      const url = selectedKeys[0];

      // 如果链接是 http:// 或 https:// 开头的外部链接，那么新窗口打开链接
      if (url.startsWith('http://') || url.startsWith('https://')) {
        window.open(url, '_blank');
        return;
      }

      const menu = menus.find(itm => itm.uri === url);
      const menuEncode = menu ? menu.encode : '';
      const menuName = menu ? menu.name : '';

      dispatchNavigate(url);
      bigdataMenu(url, menuEncode, menuName);
      setSelectKey(selectedKeys);
    }
  };

  const handleOpenChange = (keys) => {
    setDefaultOpenKeys(keys);
  };

  const changeCheckMenu = (item: any) => {
    setHeaderOpen(false);
    // 切换租户
    if (item.key === HeaderStatus.CHANGE_TENANT) {
      setShowAccountModal(showChangeEnter);
      return;
    }
    // 退出登录
    if (item.key === HeaderStatus.LOGIN_OUT) {
      get('/logout', {}, true).then(() => {
        console.log(`isALQ`, isALQ);
        logout(isALQ ? methods.handleLogoutALQ : null);
      });
      return;
    }
    //
    if (item.key === HeaderStatus.EDIT_PASSWORD) {
      setEditModal(true);
      return;
    }
    if (item.key === HeaderStatus.RESET_PASSWORD) {
      setResetModal(true);
      return;
    }
    // if (item.key === HeaderStatus.MAP_BG_CONFIG) {
    //   (true);
    // }
  };

  const setLogo = (uri) => {
    const link: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'icon';
    link.href = uri;
    document.getElementsByTagName('head')[0].appendChild(link);
  };

  const getTenantDetail = async () => { // 获取当前租户详情，并存入适配的主题模型
    try {
      const data = await getTenantInfo();
      const tenantId = getCookie('tenantId');
      !tenantId && setCookie('tenantId', data.id);
      dispatch(changeTenantInfo({ ...data }));
      setTenantInfo({ ...data });
      data.webHeaderUri && setLogo(data.webHeaderUri);
      // 获取用户自定义存储的主题模型
      const { fields } = await getConfigCustomField({
        module: 'globalUserCustomThemeForLocation'
      });
      let newTheme = data.subjectColor;
      if (fields) {
        const res = JSON.parse(fields);
        if (typeof res === 'string') {
          newTheme = res;
        } else {
          newTheme = res.theme;
        }
      }
      setCookie('location-theme', newTheme || 'default');
      dispatch(changeTheme(newTheme));
      setTimeout(() => {
        setThemeRenderReady(true);
      }, 300);
    } catch (error) {}
  };

  const onChangeTheme = debounce(async () => {
    const newTheme = theme === 'default' ? 'light' : 'default';
    // 先换再提交给接口
    setCookie('location-theme', newTheme);
    dispatch(changeTheme(newTheme));
    postConfigCustomField({
      module: 'globalUserCustomThemeForLocation',
      fields: JSON.stringify({ theme: newTheme }),
    }).then(undefined, () => {
      // 接口异常后报错，把主题切回来
      const resetTheme = newTheme === 'default' ? 'light' : 'default';
      setCookie('location-theme', resetTheme);
      dispatch(changeTheme(resetTheme));
    });
  }, 300);

  // 避免在 useMemo 中每次调用
  const isLark = useMemo(() => isLarkEnv(), []);

  const HeaderOperate: any[] = useMemo(() => {
    return [
      { label: <HeaderUserInfo tenantName={tenantInfo.name || userInfo.tenant} name={userInfo.name && userInfo.tenant && `${userInfo.name}`} avatar={userInfo.avatar}/>, key: HeaderStatus.USER_INFO },
      showChangeEnter ? { label: <div>切换租户<RightOutlined className={styles.headerOperateIcon} /></div>, key: HeaderStatus.CHANGE_TENANT, onClick: changeCheckMenu } : false,
      ...(personalPerArr[HeaderStatus.EDIT_PASSWORD] ? [{ label: <div>修改密码<RightOutlined className={styles.headerOperateIcon} /></div>, key: HeaderStatus.EDIT_PASSWORD, onClick: changeCheckMenu }] : []),
      ...(personalPerArr[HeaderStatus.RESET_PASSWORD] ? [{ label: <div>重置密码<RightOutlined className={styles.headerOperateIcon} /></div>, key: HeaderStatus.RESET_PASSWORD, onClick: changeCheckMenu }] : []),
      { label: <div>地图底色<RightOutlined className={styles.headerOperateIcon} /></div>, key: HeaderStatus.MAP_BG_CONFIG, popupClassName: styles.mapSkin, children: [
        { key: MapThemeEnum.NORMAL, label:
      <MapBGRadio
        label={MapThemeLabelEnum.NORMAL}
        value={MapThemeEnum.NORMAL}
        active={mapConfig.bg}
        setActive={setMapConfig}
      /> },
        { key: MapThemeEnum.DARK, label:
        <MapBGRadio
          label={MapThemeLabelEnum.DARK}
          value={MapThemeEnum.DARK}
          active={mapConfig.bg}
          setActive={setMapConfig}
        /> },
        { key: MapThemeEnum.LIGHT, label:
        <MapBGRadio
          label={MapThemeLabelEnum.LIGHT}
          value={MapThemeEnum.LIGHT}
          active={mapConfig.bg}
          setActive={setMapConfig}
        /> },
        { key: MapThemeEnum.WHITESMOKE, label:
        <MapBGRadio
          label={MapThemeLabelEnum.WHITESMOKE}
          value={MapThemeEnum.WHITESMOKE}
          active={mapConfig.bg}
          setActive={setMapConfig}
        /> },
      ] },
      { label: theme === 'default' ? '切换浅色模式' : '切换深色模式', key: HeaderStatus.THEME_COLOR, onClick: onChangeTheme },
      ...(isLark ? [] : [{ label: <div className={styles.headerOperateLoginOut}>退出登录</div>, key: HeaderStatus.LOGIN_OUT, onClick: changeCheckMenu }])
    ].filter(Boolean);
  }, [personalPerArr, showChangeEnter, tenantInfo, userInfo, mapConfig, theme, isLark]);

  const getTargetTenent = () => {
    tenantCheck().then((data: any) => {
      // setIsXP(data.isXiaoPeng);
      dispatch(UPDATE_TENANT_CHECK_INFO(data));
    });
  };

  const displayMenuItems = useMemo(() => {
    if (userInfo && isArray(userInfo.menusItems) && isArray(userInfo.moduleList) && isNotEmptyAny(tenantInfo)) {
      const hiddenEncodes: string[] = [];
      if (!tenantInfo.taskTemplateEnable) {
        hiddenEncodes.push('expandstore:expansionTask');
      }
      if (hiddenEncodes.length) {
        return dealWithMenu(userInfo.moduleList || [], hiddenEncodes);
      }
    }
    return userInfo?.menusItems;
  }, [userInfo?.menusItems, tenantInfo]);

  // const openXPDoc = () => {
  //   window.open(`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/file/使用指引.pdf `);
  // };

  // 集成测试小天才用，无其他意义
  const [projectText, setProjectText] = useState<string>('邻汇吧');
  useEffect(() => {
    if (getCookie('test-customized-project') === 'xtc') {
      setProjectText('小天才');
    }
  }, []);
  const changeProject = () => {
    if (getCookie('test-customized-project')) {
      removeCookie('test-customized-project');
    } else {
      setCookie('test-customized-project', 'xtc');
    }
    setTimeout(() => {
      window.location.reload();
    }, 1);
  };
  const handleJumpConsolePcEn = () => {
    const { pathname, search, hash } = window.location;
    window.location.href = `${process.env.CONSOLE_PC_EN_URL}${pathname}${search}${hash}`;
  };
  return (
    <Layout className={cs([styles.layout, themeRenderReady && styles.layoutIsGetThemeReady])}>
      <Sider
        trigger={null}
        collapsible
        className={cs(styles.siderWrap, siderWrap)}
        collapsed={collapsed}
        // 侧边栏收进的宽度
        collapsedWidth={56}
        width={170}
      >
        {/* logo */}
        <Logo collapsed={collapsed} tenantInfo={tenantInfo}/>
        {/* 菜单 */}
        {/* 区分组件文档导航和系统导航 */}
        {pageConfig?.isComponentDoc ? <Menu
          theme={theme === 'default' ? 'dark' : 'light'}
          mode='inline'
          style={{
            height: '100%',
            borderRight: 0,
            marginBottom: '48px',
            // paddingLeft: '4px',
            // paddingRight: '4px'
          }}
          selectedKeys={selectKey}
          openKeys={Array.isArray(componentDocsMenu) ? componentDocsMenu.map(item => item.name) : []}
          onOpenChange={handleOpenChange}
          onSelect={handleClick}
          items={Array.isArray(componentDocsMenu) ? componentDocsMenu.map(item => ({
            label: item.name,
            key: item.name,
            title: item.name,
            children: Array.isArray(item.children) ? item.children.map(it => ({ label: it.name, key: it.path, title: it.name })) : []
          })) : []}
        /> : <Menu
          theme={theme === 'default' ? 'dark' : 'light'}
          mode='inline'
          style={{
            height: '100%',
            borderRight: 0,
            marginBottom: '48px',
            // paddingLeft: '4px',
            // paddingRight: '4px'
          }}
          onSelect={handleClick}
          openKeys={defaultOpenKeys}
          selectedKeys={selectKey}
          onOpenChange={handleOpenChange}
          items={displayMenuItems}
        />}
        <div
          style={{
            width: collapsed ? '56px' : '170px'
          }}
          className={styles.bottomCon}
          onClick={methods.toggle}
        >
          <div className={styles.collapsed} >
            <Tooltip
              placement='top'
              title={collapsed ? '展开' : '收起'}
              open={tooltipOpen}
              overlayClassName={styles.collapsedTooltip}
            >
              <div
                onMouseEnter={() => { setTooltipOpen(true); }}
                onMouseLeave={() => { setTooltipOpen(false); }}
                onClick={() => { if (tooltipOpen) { setTooltipOpen(false); } }}
              >
                <IconFont
                  className={cs([
                    styles.bottomIconFont,
                    collapsed && styles.bottomIconFontCollapsed
                  ])}
                  iconHref='iconic_location_zhankai'
                />
              </div>
            </Tooltip>
          </div>
        </div>
        {/* {
          isXP ? <div className={styles.docsLink} onClick={openXPDoc}>
            <FileTextOutlined />
            <span className='pl-8'>使用指引</span>
          </div> : null
        } */}
      </Sider>
      <Layout className={styles.leftLayout} style={{ marginLeft: collapsed ? 56 : 170 }}>
        <Header className={styles.header}>
          <div className={styles.leftWrap}>
            {/* /dfrc/ 路由使用 Tab 导航，其余使用面包屑 */}
            {/^\/dfrc\//.test(location.to.pathname) ? (
              <V2Tabs
                className={styles.dfrcHeaderTabs}
                activeKey={location.to.pathname}
                onChange={(key) => dispatchNavigate(key)}
                items={[
                  { key: '/dfrc/storemap', label: '门店地图' },
                  { key: '/dfrc/performancereport', label: '绩效报表' },
                  { key: '/dfrc/storetrend', label: '开店趋势' },
                ]}
              />
            ) : (
              <>
                {/* 旧收起按钮 */}
                <Breadcrumb
                  location={location}
                  userInfo={userInfo}
                  // getMenuMap={getMenuMap}
                  setPageConfig={setPageConfig}
                  selectKey={selectKey}
                  setSelectKey={setSelectKey}
                  setHavePermission={setHavePermission}
                />
                {
                  (process.env.NODE_TYPE === 'ie' || process.env.NODE_TYPE === 'te') && !process.env.CUSTOMIZED_PROJECT ? <button onClick={changeProject}>{projectText}</button> : <></>
                }
              </>
            )}
          </div>
          <div className={cs([
            styles.right,
            headerOpen && styles.rightHeaderOpen
          ])}>
            {isALQ ? (<>
              {/* <div className={styles.languageCon} onClick={handleJumpConsolePcEn}>
                <div className={styles.letterCon}>
                  <span className={styles.text}>EN</span>
                </div>
              </div> */}
              <Tooltip title='切换至英文'>
                <div className={styles.languageCon} onClick={handleJumpConsolePcEn}>
                  <div className={styles.letterCon}>
                    <span className={styles.text}>EN</span>
                  </div>
                </div>
              </Tooltip>
              {/* <span
                role='button'
                onClick={handleJumpConsolePcEn}
                style={{
                  cursor: 'pointer',
                  userSelect: 'none',
                  marginRight: 10,
                  fontSize: 14,
                  lineHeight: '22px',
                }}
              >
              中文
              </span> */}
            </>) : null}
            <Tooltip
              open={downLoadTipOpen}
              placement='bottom'
              trigger='hover'
              title='文件下载记录'
              zIndex={10000}
              onOpenChange={methods.handleDownLoadTipOpenChange}
              overlayClassName={styles.collapsedTooltip}>
              <div id='layout-top-download-draw-icon' className={cs([styles.rightTag, downLoadTipHigh && styles.rightTagHigh])} onClick={() => setDownLoadVisible(true)}>
                <IconFont className={styles.rightTagIcon} iconHref='icondownload'/>
              </div>
            </Tooltip>
            <div className={cs([styles.downloadAnimate, downLoadTipAnimate.animation && styles.downloadAnimating])} style={{ left: downLoadTipAnimate.left }}>
              <div className={styles.downloadAnimateMask}></div>
              <IconFont className={styles.downloadAnimateIcon} iconHref='icondownload'/>
            </div>
            <div className={styles.rightDivider}></div>
            <Dropdown
              overlayClassName={styles.headerOperate}
              menu={{ items: HeaderOperate }}
              onOpenChange={(v: boolean) => setHeaderOpen(v)}
            >
              <a className={styles.dropDownLink} onClick={(e) => e.preventDefault()}>
                <span className={styles.avatarImg}>
                  {userInfo.avatar ? <img src={userInfo.avatar} alt='' /> : <span className={styles.icon}></span>}
                </span>
                {/* 企业名称和员工姓名(姓名没有的时候接口返回的是手机号 */}
                {userInfo.name && userInfo.tenant && `${userInfo.name}`}
                { headerOpen ? <DownOutlined className={cs(styles.headerIcon, styles.headerIconUp)}/> : <DownOutlined className={styles.headerIcon}/> }
              </a>
            </Dropdown>
          </div>
        </Header>
        {/* <div id='micro-organization'></div> */}
        <UserInfoContextProvider userInfo={userInfo} tenantInfo={tenantInfo} getTenantDetail={getTenantDetail} pageConfig={pageConfig}
          mapConfig={mapConfig}
        >
          <Content className={cs(styles.content, isFullPage ? styles.isFull : '')}>
            {havePermission ? children : <NotFound text='暂无权限，请联系企业管理员开通' />}
          </Content>
        </UserInfoContextProvider>
      </Layout>
      {/* 切换租户 */}
      <ChangeAccount showAccountModal={showAccountModal} setShowAccountModal={setShowAccountModal} />
      {/* 修改密码 */}
      <EditPasswordModal visible={editModal} setVisible={setEditModal}/>
      {/* 忘记密码（重设密码） */}
      <ResetPasswordModal visible={resetModal} setVisible={setResetModal}/>
      {/* 开发前必读 */}
      <MustReadBeforeDev/>
      <DownLoadRecord visible={downLoadVisible} setVisible={setDownLoadVisible}/>
      {/* 水印 */}
      <V2WaterMark show={!!waterText} content={waterText} />
    </Layout>
  );
};

export default Component;
